import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "@/components/global/mixins/Mixin.js";
import VueMeta from 'vue-meta'

 


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  VueMeta,
  render: h => h(App)
}).$mount('#app')
